import initialState from "../../store/initialState";

const reportsInitialState = {
	...initialState,
	reportData: {},
	payslips: null
};

export default reportsInitialState;
